export default {
  LOGIN_SERVER_URL: "https://ui8.net",
};
